import { hideAllSubNavs } from './desktop-nav'

// NOTE: this JS only deals with the non-mobile search. The mobile search
// doesn't need any JS to function as designed.

const searchSwapWidth = 1024
let searchVpWidth     = null
let searchInput     = null
let searchTrigger     = null
let searchForm        = null
let searchClose       = null
let searchSubmit = null
var searchIsOpen = false;

export function initialize() {
  inspectEnvironment()
}


export function inspectEnvironment() {
  searchVpWidth = window.innerWidth

  if ((searchVpWidth >= searchSwapWidth)) {
    searchTrigger = document.querySelector('[data-search-trigger]')
    searchInput = document.querySelector('[data-search-input]')
    searchForm    = document.querySelector('[data-search-form]')
    searchClose   = document.querySelector('[data-search-close]')
    searchSubmit   = document.querySelector('[data-search-form] input[type="submit"]')

    if (!searchTrigger || !searchForm || !searchClose || !searchInput) {
      return
    }

    addListeners()
  }
}


export function addListeners() {
  searchTrigger.addEventListener('click', showSearch, false)
  searchClose.addEventListener('click', hideSearch, false)
}

export function showSearch() {
  hideAllSubNavs() // Defined in desktop-nav.js
  searchTrigger.blur()
  searchForm.classList.add('is-visible')
  searchInput.focus()
  searchIsOpen = true;
}

export function hideSearch() {
	searchIsOpen = false;
	if(searchForm) {
		searchForm.classList.remove('is-visible')		
	}
	if(searchTrigger) {
		searchTrigger.focus()			
	}
}

$(document).on('keydown',function(e) {
	if(searchIsOpen) {
	    if(e.key === "Escape") {
			hideSearch();
		}
		var focusedEl = document.activeElement;
		if(focusedEl === searchInput) {
			searchInputEvent(e);
		}
		if(focusedEl === searchClose) {
			searchCloseEvent(e);
		}
		if(focusedEl === searchSubmit) {
			searchSubmitEvent(e);
		}
	}
});


function searchInputEvent(event) {
	if(event.shiftKey && event.keyCode == 9) {
		event.preventDefault();
		$(searchClose).focus();
	}
}
function searchCloseEvent(event) {
	if(event.shiftKey && event.keyCode == 9) {
		event.preventDefault();
		searchInput.focus();
	} 
	if(event.keyCode == 9 && !event.shiftKey) {
		event.preventDefault();
		hideSearch();
	}
}
function searchSubmitEvent(event) {
	if(event.shiftKey && event.keyCode == 9) {
		event.preventDefault();
		searchInput.focus();
	}
}